let logo = `
/------------------------ooooooooooooooooooooooooo
:........................oooo     ooooooo     oooo
:........................oooo      ooooo      oooo
:........................oooo       ooo       oooo
:........................oooo        o        oooo
:........................oooo    o       o    oooo
:........................oooo    ooo   ooo    oooo
:........................oooo    ooooooooo    oooo
:........................oooo    ooooooooo    oooo
:........................oooo    ooooooooo    oooo
:........................oooo    ooooooooo    oooo
:........................ooooooooooooooooooooooooo
ooooooooooooooooooooooooo........................:
oooo     ooooooo     oooo........................:
oooo      ooooo      oooo........................:
oooo       ooo       oooo........................:
oooo        o        oooo........................:
oooo    o       o    oooo........................:
oooo    ooo   ooo    oooo........................:
oooo    ooooooooo    oooo........................:
oooo    ooooooooo    oooo........................:
oooo    ooooooooo    oooo........................:
oooo    ooooooooo    oooo........................:
ooooooooooooooooooooooooo------------------------/
`

// let logo = `
// /------------------------ddddddddddddddddddddddddd
// :........................dddd:\`\`.+ddddddd+.\`\`:dddd
// :........................dddh     -hdddh-     hddd
// :........................dddh      .hdh.      hddd
// :........................dddh       \`o\`       hddd
// :........................dddh    /       :    hddd
// :........................dddh    hs     oy    hddd
// :........................dddh    hds\` \`sdy    hddd
// :........................dddh    hddhydddy    hddd
// :........................dddh    hdddddddy    hddd
// :........................dddh    hdddddddy    hddd
// :........................ddddo++odddddddddo++sdddd
// soooooooooooooooooooooooo++++++++++++++++++++++++s
// ddddhsosdddddddddsoohdddd........................:
// dddd\`   \`ydddddy.    dddd........................:
// dddd      sddds\`     hddd........................:
// dddd       +do       hddd........................:
// dddd    .   -   \`    hddd........................:
// dddd    y-     .y    hddd........................:
// dddd    hd:   -hh    hddd........................:
// dddd    hdd+:+ddh    hddd........................:
// dddd    hdddddddh    hddd........................:
// dddd    hdddddddh    hddd........................:
// dddd.  .hdddddddd.  .dddd........................:
// ddddddddddddddddddddddddd------------------------/
// `

export default logo